import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";

const sleep = () => new Promise((resolve) => setTimeout(resolve, 500));

//based on environment (dev or prod), settings will be picked.
axios.defaults.baseURL = "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/";

//process.env.Entrez_API_URL; //"http://localhost:5000/api/";
//for cookies to work:
//axios.defaults.withCredentials =true;

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export interface DataError {
  // this comes from server as part of error
  type: string;
  title: string;
  status: number;
  traceId: string;
  errors: any;
}

axios.interceptors.response.use(
  //onfulfilled part
  async (response) => {
    // async await is the cleaner way of using promises. (no need to uses then..catch etc..)

    if(process.env.NODE_ENV === 'development'){
      await sleep(); //this means wait until that method finishes and then return response.
    }
     
   return response;
  },

  //onrejected part
  (error: AxiosError) => {
    console.log("Caught by Interceptor....");
    console.log(error.response);
    toast.error("Rejected");
    
    const { data, status } = error.response!; //! overwrites the type safity, since we are not going to define type for each kind of response from the server.

    let newDataObject = data as DataError; // we used the interface as typescript was restricting the usage without any type

    switch (status) {
      case 400:
        if (newDataObject.errors) {
          const modelStateErrors: string[] = [];
          for (const key in newDataObject.errors) {
            if (newDataObject.errors[key]) {
              modelStateErrors.push(newDataObject.errors[key]);
            }
          }

          throw modelStateErrors.flat();
        }

        toast.error(newDataObject.title);
        break;

      case 401:
        toast.error(newDataObject.title ); 
        break;

      case 500:
        toast.error(newDataObject.title);
        //history.push('/server-error');
        break;
    }

    return Promise.reject(error.response);
  }
);

const requests = {
  get: <T>(url: string, params?: URLSearchParams) => axios.get<T>(url, {params}).then(responseBody),
  // post: <T>(url: string, body: {}) => axios.post<T>(url, body).then(responseBody),
  // put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
  // delete: (url: string) => axios.delete(url).then(responseBody),
};

const Entrez = {
  getDBs: (params: URLSearchParams) => requests.get<any>("einfo.fcgi", params),
  getSearchResults: (params: URLSearchParams) => requests.get<any>("esearch.fcgi", params),
  getSearchResultSummary: (params: URLSearchParams) => requests.get<any>("esummary.fcgi", params),

  // efetch changed to esummary - on comment from Dinesh as GDS database results were empty from efetch. 
  getSearchResultDetails: (params: URLSearchParams) => requests.get<any>("esummary.fcgi", params),

  //for medline formatted data.
  getSearchResultDetailsMedlineFormat: (params: URLSearchParams) => requests.get<any>("efetch.fcgi", params),
};


const agentEntrez = {
  Entrez
};

export default agentEntrez;

